import { forwardRef } from 'react';
import type { PropsWithChildren } from 'react';
import classNames from '../../../utils/classNames';

interface ModalScrollableSectionProps extends PropsWithChildren {
    className?: string;
}

export function ModalScrollableLayout({ children, className }: ModalScrollableSectionProps) {
    return (
        <div className={classNames('relative flex max-h-[92vh] min-h-0 flex-col py-6', className)}>
            {children}
        </div>
    );
}

export const ModalScrollableBody = forwardRef<HTMLDivElement, ModalScrollableSectionProps>(
    ({ children, className }, ref) => (
        <div ref={ref} className={classNames('min-h-0 flex-1 overflow-y-auto', className)}>
            {children}
        </div>
    )
);
ModalScrollableBody.displayName = 'ModalScrollableBody';

export function ModalScrollableFooter({ children, className }: ModalScrollableSectionProps) {
    return (
        <div className={classNames('shrink-0 border-t border-gray-200 bg-white', className)}>
            {children}
        </div>
    );
}
